<style scoped lang="less">
/** 最外层div盒子*/
.forbidden-box {
  padding-top: 10vh;
  font-family: PingFang SC;
  font-style: normal;
  color: #141B27;
  width:100%;
  margin: auto;
  text-align: center;
  .article{
    margin: .4rem auto 0;
    font-weight: normal;
    width:100%;
    text-align: center;
    font-size: .2rem;
    line-height:.3rem;
  }
  .image{
    width: 1.8rem;
    height: 1.8rem;
    margin: .3rem auto;
    display: block;
  }
  .footer{
    margin: .1rem auto 0;
    font-size: .2rem;
    line-height: .2rem;
    text-align: center;
    color: #696D75;

  }
}
</style>
<script>
export default {
  data() {
    return {
    };
  }
};
</script>

<template>
  <!--  组件最外层盒子-->
  <div class="forbidden-box">
    <h1>尊敬的用户您好！</h1>
    <article class="article">
      您的账号目前涉嫌违规，当前服务已停止。请您遵守平台账号使用规范，频繁操作将导致账号封禁。详情请咨询壁虎看看运营方。
    </article>
    <img src="https://s6.bihukankan.com/img/16781553481678154979030_2C35EAFE-4D90-45ca-8DE8-01B57386C4BF.png" alt="qrcode" class="image">
    <footer class="footer">
      扫码添加客服微信
    </footer>
  </div>
</template>
